// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function campaign_encode(v) {
  return Js_dict.fromArray([
              [
                "campaign_id",
                Decco.intToJson(v.campaign_id)
              ],
              [
                "action",
                Decco.optionToJson(Decco.stringToJson, v.action)
              ],
              [
                "pending_priority",
                Decco.optionToJson(Decco.intToJson, v.pending_priority)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([[
                "campaigns",
                Decco.listToJson(campaign_encode, v.campaigns)
              ]]);
}

export {
  campaign_encode ,
  t_encode ,
  
}
/* No side effect */
